
<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>



        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">
              Location to Close

            </h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Is_primary_location">
                    Was this location the ICD's main location (official corporate address)
                    <code>*</code>

                  </label>
                  <div class="col-md-4">
                    <div class="form-group">

                      <select class="form-control" disabled  [ngClass]="{'is-valid': f.Is_primary_location.valid, 'is-invalid' : submitted && !f.Is_primary_location.valid}"
                           (change)="onPrimaryChange()"    formControlName="Is_primary_location" style="width: 100%;">
                        <option selected="selected" value="">Please select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>

                      <div *ngIf="submitted && f.Is_primary_location.errors" class="invalid-feedback">
                        <div *ngIf="f.Is_primary_location.errors.required"> Was this location the ICD's main location (official corporate address) is required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-check mb-3">
                  <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

                  <label for="acceptTerms" class="form-check-label">US</label><br />
                  <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
                  <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
                  <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
                </div>
              </div>
            </div>
            <div>
              <label *ngIf="Is_primary_location" >Select new main location</label>

              <table *ngIf="Is_primary_location" class="table table-bordered">
                <thead>                  
                  <tr>
                    <th>Select</th>
                    <th>Name</th>
                    <th>Location Type</th>
                    <th>Address</th>
                    <th>Address 2</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Postal Code</th>
                    <th>County</th>
                    <!-- Add other columns as needed -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of Locs_Data">
                    <td>
                      <input type="radio" formControlName="selectedRow" [value]="item.id" />
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.location_Type }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.address2 }}</td>
                    <td>{{ item.city }}</td>
                    <td>{{ item.state__c }}</td>
                    <td>{{ item.postal_Code }}</td>
                    <td>{{ item.county }}</td>
                    <!-- Display other columns as needed -->
                  </tr>
                </tbody>
              </table>


            </div>

            <div class="row">


              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Distributor_Code">Distributor Code <code>*</code></label>
                  <input type="text" formControlName="Distributor_Code" class="form-control"
                         [ngClass]="{'is-valid': f.Distributor_Code.valid, 'is-invalid' : submitted && f.Distributor_Code.valid}" placeholder="Enter Full Distributor_Code"
                         appAiHint="Distributor Code" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Distributor_Code.errors" class="invalid-feedback">
                    <div *ngIf="f.Distributor_Code.errors.required">Distributor_Code  is required</div>
                  </div>

                </div>




              </div>
              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Corporation Name <code>*</code></label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                         [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                         appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>




              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name <code>*</code></label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                               (change)="onCheckboxNC($event)">
                      <ng-option *ngFor="let o of NC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                  <div class="col-md-12">
                    <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                      <ng-option *ngFor="let o of PO_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                  <div class="col-md-12">


                    <ng-select [searchable]="true" formControlName="Regional_Consultant"
                               (change)="onCheckboxRC($event)">
                      <ng-option *ngFor="let o of RC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>




              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Address">Address<code>*</code></label>
                  <input type="text" formControlName="Address" class="form-control"
                         [ngClass]="{'is-valid': f.Address.valid, 'is-invalid' : submitted && f.Address.valid}" placeholder="Enter  Address "
                         appAiHint="Address" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Address.errors" class="invalid-feedback">
                    <div *ngIf="f.Address.errors.required">Address  is required</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Company_Address2">Address 2(e.g. Suite 100)</label>
                  <input type="text" formControlName="Company_Address2" class="form-control"
                         [ngClass]="{'is-valid': f.Company_Address2.valid, 'is-invalid' : submitted && f.Company_Address2.valid}" placeholder="Enter Address 2 "
                         appAiHint="Company Address 2" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Company_Address2.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Address2.errors.required">Address 2  is required</div>
                  </div>

                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Company_City">City <code>*</code></label>
                  <input type="text" formControlName="Company_City" class="form-control"
                         [ngClass]="{'is-valid': f.Company_City.valid, 'is-invalid' : submitted && f.Company_City.valid}" placeholder="Enter  City"
                         appAiHint="Company City" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Company_City.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_City.errors.required">City is required</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

                <div class="form-group">

                  <div class="col-md-12">
                    <label class="form-label">State  <code>*</code></label>
                    <select formControlName="Company_State" #selectEl class="form-control select2"
                            [select2]="select2Options" [ngClass]="{ 'is-invalid': submitted && f.Company_State.errors }">
                      <option value="" disabled>Please Select</option>

                      <option *ngFor="let c of ddlUSStates" [ngValue]="c.value">{{ c.name }}</option>
                    </select>
                    <div *ngIf="submitted && f.Company_State.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_State.errors.required">State is required</div>
                    </div>


                  </div>




                </div>
              </div>


              <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

                <div class="form-group">

                  <div class="col-md-12">
                    <label class="form-label">Province <code>*</code></label>
                    <select formControlName="Company_Province" class="form-control select2" [ngClass]="{ 'is-invalid': submitted && f.Company_Province.errors }">
                      <option value="" disabled>Please Select</option>

                      <option *ngFor="let c of ddlCAProvinence" [ngValue]="c.value">{{ c.name }}</option>
                    </select>
                    <div *ngIf="submitted && f.Company_Province.errors" class="invalid-feedback">
                      <div *ngIf="f.Company_Province.errors.required">Province  is required</div>
                    </div>


                  </div>




                </div>
              </div>



              <div class="col-sm-4">
                <div class="form-group">
                  <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
                  <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
                  <input type="text" formControlName="Company_Postal_Code" class="form-control"
                         [ngClass]="{'is-valid': f.Company_Postal_Code.valid, 'is-invalid' : submitted && f.Company_Postal_Code.valid}" placeholder="Enter  postal Code (Zip)"
                         appAiHint="Company Postal Code" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Company_Postal_Code.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Postal_Code.errors.required">Postal Code  is required</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label  class="col-form-label  col-md-12" for="login-Location_Type">Location Type<code>*</code></label>
                  
                  <input type="text" formControlName="Location_Type" class="form-control"
                         [ngClass]="{'is-valid': f.Location_Type.valid, 'is-invalid' : submitted && f.Location_Type.valid}" placeholder="Enter  Location_Type"
                         appAiHint="Location Type" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Location_Type.errors" class="invalid-feedback">
                    <div *ngIf="f.Location_Type.errors.required">Location_Type  is required</div>
                  </div>

                </div>
              </div>


            </div>

          </div>

          </div>


         


      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>

  </form>

</div>

